/**
 * Combine all reducers in this file and export the combined reducers.
 * If we were to do this in store.js, reducers wouldn't be hot reloadable.
 */

import { fromJS } from 'immutable';

import {
  USER_DATA,
  USER_TOKEN,
  ORGANIZATIONS_DATA,
  ORGANIZATIONS_FETCHED,
  CURRENT_ORAGNIZATION_DATA,
  SET_UNAUTHORIZED,
  CONSOLE_LOG,
  SET_IS_LOADED,
  USER_FETCHED,
  SET_SMALL_MAIN_NAV,
  SET_HAS_ALL_ORGANIZATIONS,
  SET_REINTALIZE
} from './constants';
/*
 * routeReducer
 *
 * The reducer merges route location changes into our immutable state.
 * The change is necessitated by moving to react-router-redux@4
 *
 */

const userState = fromJS({
  user: {},
  token: '',
  currentOrganization: {},
  organizations: [],
  isOrganizationsFetched: false,
  isUserFetched: false,
  isLoaded: false,
  isSmallMainNav: true,
  organizationCount: 0
});



function appReducer(state = userState, action) {
  switch (action.type) {
    case USER_DATA:
      if (action.payload && action.payload.organizations && state.get('organizations').toJS().length > 0) {
        return state.merge({'user': fromJS(action.payload), 'organizations': fromJS(action.payload.organizations)});
      }
      return state.set('user', fromJS(action.payload));     
    case USER_TOKEN:
      return state.set('token', fromJS(action.payload));
    case ORGANIZATIONS_DATA:
      return state.set('organizations', fromJS(action.payload));
    case ORGANIZATIONS_FETCHED:
      return state.set('isOrganizationsFetched', fromJS(action.value));
    case CURRENT_ORAGNIZATION_DATA:
      return state.set('currentOrganization', fromJS(action.payload));
    case SET_IS_LOADED:
      return state.set('isLoaded', fromJS(action.value));
    case SET_SMALL_MAIN_NAV:
      return state.set('isSmallMainNav', fromJS(action.value));
    case USER_FETCHED:
      return state.set('isUserFetched', fromJS(action.value));
    case SET_HAS_ALL_ORGANIZATIONS:
      return state.set('organizationCount', fromJS(state.get('organizationCount')+1));
    case CONSOLE_LOG:
      console.log(action.payload);
      return state;
    case SET_REINTALIZE:
      return state = userState;
    case SET_UNAUTHORIZED:
      return state = userState;
    default:
      return state;
  }
}
/**
 * Creates the main reducer with the asynchronously loaded ones
 */
export default appReducer;
